import { autoserialize } from 'cerialize';

export class RiderNote {
  @autoserialize
  rideRequestId: number;

  @autoserialize
  note: string;
}
